module.exports = __webpack_public_path__ + "media/images/logos/courtsdesk-no-text-white-35x23-ffb48de72068ffeeccd03199d199ee85.svg";